'use client'

import { usePathname } from 'next/navigation'

export type PageTheme = 'default' | 'gray' | 'purple'

// Для всех страниц услуг и сервисных центров
const GRAY_BG_EXACT_PATHS = new Set([
	'/service/',
	'/services/applecare-plus/',
	'/services/credit/',
	'/services/insurance/',
	'/services/iport-card/',
	'/services/limits/',
	'/services/plus/',
	'/services/trade-in/',
	'/promo/valentines-day-25/',
	'/found-lower-price/',
	'/delivery/',
	'/gift/',
	'/services/care/',
	'/promo/iphone-17/',
	'/promo/iphone-18/',
	'/cart/'
])

const PURPLE_BG_EXACT_PATHS = new Set(['/promo/scratch/'])
const B2B_ROUTE_REGEXP = /^\/b2b(\/.*)?$/

const getPageTheme = (pathname: string): PageTheme => {
	if (PURPLE_BG_EXACT_PATHS.has(pathname)) {
		return 'purple'
	}

	if (
		pathname.includes('/service/') ||
		GRAY_BG_EXACT_PATHS.has(pathname) ||
		pathname.includes('/promo/') ||
		B2B_ROUTE_REGEXP.test(pathname)
	) {
		return 'gray'
	}

	return 'default'
}

export const usePageTheme = (): PageTheme => {
	const pathname = usePathname()

	return getPageTheme(pathname)
}
